import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';

export const setBrowseSettingsWidgetTheatreView = createAction(
  `${reduxKey}.SET_BROWSESETTINGS_WIDGET_THEATRE_VIEW`,
  (theatreView: 'zoomed_out' | 'zoomed_in') => ({ theatreView })
);

export const setBrowseSettingsWidgetInvisibleBrowsing = createAction(
  `${reduxKey}.SET_BROWSESETTINGS_WIDGET_INVISIBLE_BROWSING`,
  (invisibleBrowsing: boolean) => ({ invisibleBrowsing })
);

export const setBrowseSettingsWidgetBrowseLimit = createAction(
  `${reduxKey}.SET_BROWSESETTINGS_WIDGET_BROWSE_LIMIT`,
  (browseLimit: number) => ({ browseLimit })
);

export const setBrowseSettingsWidgetBrowsePagingMode = createAction(
  `${reduxKey}.SET_BROWSESETTINGS_WIDGET_BROWSE_PAGING_MODE`,
  (browsePagingMode: 'infinite' | 'paged') => ({ browsePagingMode })
);

export const saveBrowseSettings = createAction(
  `${reduxKey}.SAVE_BROWSE_SETTINGS`,
  () => ({})
);

export const saveBrowseSettingsSuccess = createAction(
  `${reduxKey}.SAVE_BROWSE_SETTINGS_SUCCESS`,
  () => ({})
);

export const saveBrowseSettingsFailure = createAction(
  `${reduxKey}.SAVE_BROWSE_SETTINGS_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);
